import HttpService from '@/api/HttpService';

import {
  SET_CURRENT_DWOLLA_CUSTOMER_ID,
} from '../mutation-types';

export default {
  namespaced: true,
  state: {
    currentDwollaCustomerId: null,
  },
  mutations: {
    [SET_CURRENT_DWOLLA_CUSTOMER_ID](state, customerId) {
      state.currentDwollaCustomerId = customerId;
    },
  },
  actions: {
    getToken(_, dwollaCustomerId) {
      return HttpService.postV2(`/iav-token/${dwollaCustomerId}`);
    },
    async deleteFundingSource(_, fundingSourceId) {
      return HttpService.deleteV2(`/funding-sources/${fundingSourceId}`);
    },
    createDwollaUser(_, userId) {
      return HttpService.postV2('users/dwolla/customer', { userId })
      .then(response => response)
      .catch((err) => {
        throw err;
      });
    },
    updateDwollaCustomer() {
      return HttpService.putV2('users/dwolla/customer')
      .catch((err) => {
        throw err;
      });
    },
    getClientToken(_, payload) {
      return HttpService.postV2('funding-sources/client-token', payload);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/fundingSource.js